module.exports = __webpack_public_path__ + "static/media/gg.49214809.svg";